module.exports = function() {

    if (!document.getElementsByClassName('gridder')[0]) return false;

    jQuery('.gridder').gridderExpander({
        scroll: false,

        scrollOffset: 30,

        scrollTo: "panel",

        animationSpeed: 400,

        animationEasing: "easeInOutExpo",

        showNav: false

    });
};